import { render, staticRenderFns } from "./SettingIntegrations.vue?vue&type=template&id=12f43de3&"
import script from "./SettingIntegrations.vue?vue&type=script&lang=js&"
export * from "./SettingIntegrations.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/admin_settings.css?vue&type=style&index=0&lang=css&"
import style1 from "./SettingIntegrations.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports